module.exports = __webpack_public_path__ + "img/closeSupport.3d967d2a.svg";